/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * response of GET /media_list/prtimes_media_lists/{media_list_id}
 * @export
 * @interface GetMediaListResponse
 */
export interface GetMediaListResponse {
    /**
     * メディアリスト名
     * @type {string}
     * @memberof GetMediaListResponse
     */
    mediaListName: string;
    /**
     * プレスリリース配信元のメールアドレス
     * @type {string}
     * @memberof GetMediaListResponse
     */
    fromEmail: string;
    /**
     * プレスリリース配信元のメール送信者名（（表示しません）とかある）
     * @type {string}
     * @memberof GetMediaListResponse
     */
    senderName: string;
    /**
     * 形式(Y-m-d\TH:i:sP)
     * @type {string}
     * @memberof GetMediaListResponse
     */
    updatedAt: string;
}

/**
 * Check if a given object implements the GetMediaListResponse interface.
 */
export function instanceOfGetMediaListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mediaListName" in value;
    isInstance = isInstance && "fromEmail" in value;
    isInstance = isInstance && "senderName" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

export function GetMediaListResponseFromJSON(json: any): GetMediaListResponse {
    return GetMediaListResponseFromJSONTyped(json, false);
}

export function GetMediaListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMediaListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaListName': json['media_list_name'],
        'fromEmail': json['from_email'],
        'senderName': json['sender_name'],
        'updatedAt': json['updated_at'],
    };
}

export function GetMediaListResponseToJSON(value?: GetMediaListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_list_name': value.mediaListName,
        'from_email': value.fromEmail,
        'sender_name': value.senderName,
        'updated_at': value.updatedAt,
    };
}

